export default __webpack_public_path__ + "static/media/FacilityTypeCountIcon.7f7fa4ee.svg";